import { HttpContextToken } from '@angular/common/http';

export const SKIP_SUCCESS_INTERCEPTOR = new HttpContextToken<boolean>(
  () => false
);
